import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable()
export class DomManipulationService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(@Inject(DOCUMENT) private document: any) {}

  public addScriptTag(
    scriptSource: string,
    scriptTagId: string,
    async?: boolean,
    defer?: boolean
  ): void {
    if (!this.document.getElementById(scriptTagId)) {
      const script = this.document.createElement('script');

      script.type = 'text/javascript';
      script.src = scriptSource;
      script.id = scriptTagId;
      script.async = !!async;
      script.defer = !!defer;
      this.document.head.appendChild(script);
    }
  }
}
